/* eslint-disable react/destructuring-assignment */
import { Checkbox, TextField } from '@material-ui/core';
import React from 'react';
import format from 'date-fns/format';
import Icon from '@mdi/react';
import { mdiPercentOutline } from '@mdi/js';
import OptionsCategorySelection from './OptionsCategorySelection';
import NumberCurrancyField from './NumberCurrancyField';
import { STATUS_OPENED } from '../../../shared/utils/constants';
import { getUTCDateFromMilliseconds } from '../../../shared/utils/smartutils';

export function columnsGenerate(
  t,
  onStateUpdate,
  categories,
  onViewDiscount,
  hideChecked,
  hideDiscount
) {
  return [
    {
      field: 'checked',
      hidden: hideChecked,
      render: (rowData) => (
        <>
          <Checkbox
            name="checked"
            checked={rowData.generate}
            onChange={(event, value) => {
              const newData = {
                ...rowData,
                generate: value,
              };
              onStateUpdate(rowData, newData);
            }}
          />
        </>
      ),
    },
    { title: t('general.code'), field: 'id' },
    { title: t('general.student'), field: 'student.fullName' },
    { title: t('general.responsible-account'), field: 'responsible.fullName' },
    { title: t('general.quota'), field: 'quota' },
    {
      title: t('general.status'),
      field: 'status',
      render: (rowData) => {
        if (rowData.id !== 0) {
          const due =
            new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              new Date().getDate() - 1,
              23
            ) > new Date(rowData.dueDate);
          if (rowData.status === STATUS_OPENED && due) {
            return t(`general.vanquished`);
          }
          if (rowData.status === STATUS_OPENED) {
            return t(`general.receiving`);
          }
          return t(`general.${rowData.status}`);
        }
        return '';
      },
    },
    {
      title: t('general.category'),
      field: 'category.name',
      render: (rowData) => (
        <OptionsCategorySelection
          disabled={rowData.id !== 0}
          category={{
            ...rowData.category,
          }}
          categories={categories}
          handleChange={(value) => {
            const newData = {
              ...rowData,
              category: value,
            };
            onStateUpdate(rowData, newData);
          }}
        />
      ),
    },
    {
      title: t('general.due-date'),
      field: 'dueDate',
      render: (rowData) => (
        <TextField
          disabled={rowData.id !== 0}
          type="date"
          defaultValue={format(
            getUTCDateFromMilliseconds(rowData.dueDate),
            'yyyy-MM-dd'
          )}
          onChange={(evt) => {
            const day = new Date(evt.target.value).getUTCDate();
            const month = new Date(evt.target.value).getMonth();
            const year = new Date(evt.target.value).getFullYear();
            const newData = {
              ...rowData,
              dueDate: new Date(year, month, day).getTime(),
            };
            onStateUpdate(rowData, newData);
          }}
        />
      ),
    },
    {
      title: t('general.value'),
      field: 'value',
      cellStyle: { width: '1rem' },
      render: (rowData) => (
        <>
          <TextField
            disabled={rowData.id !== 0}
            name="value"
            style={{ width: '8rem' }}
            value={rowData.value}
            onBlur={(evt) => {
              const removeCurrancy = evt.target.value.replace(/[R$. ]/g, '');
              const formatted = removeCurrancy.replace(',', '.');
              const floatValue = parseFloat(formatted);
              const newData = {
                ...rowData,
                value: floatValue,
              };
              onStateUpdate(rowData, newData);
            }}
            InputProps={{
              inputComponent: NumberCurrancyField,
            }}
          />
        </>
      ),
    },
    {
      title: t('general.percentage-discount'),
      field: 'discountConfigurations',
      hidden: hideDiscount,
      render: (rowData) => {
        return (
          <span data-toggle="tooltip" title={t('general.discount')}>
            <Icon
              path={mdiPercentOutline}
              size={1}
              onClick={() => onViewDiscount(rowData.discountConfigurations)}
            />
          </span>
        );
      },
    },
  ];
}

export function columnsComposition(t) {
  return [
    { title: t('general.category'), field: 'category' },
    {
      title: t('general.date'),
      field: 'dueDate',
      render: (rowData) =>
        format(getUTCDateFromMilliseconds(rowData.dueDate), 'dd/MM/yyyy'),
    },
    { title: t('general.quota'), field: 'quota' },
    {
      title: t('general.value'),
      field: 'value',
      render: (rowData) =>
        rowData.value.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
  ];
}

export function columnsDiscount(t) {
  return [
    { title: t('general.before-dueDate'), field: 'daysBeforeExpiration' },
    { title: t('general.percentage-discount'), field: 'discountPercentage' },
  ];
}
